import Footerlogo from "./../../assets/logo1.png";

const Footer = () => {
  const styles = {
    footer: {
      backgroundColor: "#111827",
      color: "#fff",
      padding: "20px 0",
      textAlign: "center",
      overflow: "hidden",
    },
    container: {
      width: "100%",
     
      margin: "0 auto",
      padding: "0 20px",
    },
    footerGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
      gap: "20px",
      textAlign: "left",
    },
    footerColumn: {
      padding: "10px",
    },
    footerBanner: {
      marginTop: "20px",
      backgroundColor: "#1f2937",
      padding: "10px",
      textAlign: "center",
      fontSize: "14px",
    },
    link: {
      color: "#bbb",
      textDecoration: "none",
      display: "block",
      marginBottom: "8px",
      maxWidth: "150px"
    },
    logo: {
      width: "200px",
      marginTop: "10px",
    },
    heading: {
      fontWeight: "bold",
      fontSize: "18px",
      marginBottom: "10px",
    },
    contactText: {
      color: "#bbb",
      fontSize: "14px",
      lineHeight: "1.6",
      
      
    },
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.footerGrid}>
          {/* Column 1 - Logo and Description */}
          <div style={styles.footerColumn}>
            <img src={Footerlogo} alt="Company Logo" style={styles.logo} />
            <p style={styles.contactText}>
            At Samson and Associates, we specialize in transforming ideas into timeless spaces. Based in Hosur, we offer end-to-end architectural, interior, and engineering solutions across Tamil Nadu. Our team blends creativity, functionality, and sustainability to deliver designs that inspire and endure.
            </p>
          </div>

          {/* Column 2 - Quick Links */}
          <div style={styles.footerColumn}>
            <h2 style={styles.heading}>Quick Links</h2>
            <ul style={{ padding: 0, listStyleType: "none" }}>
              <li><a href="/" style={styles.link}>Home</a></li>
              <li><a href="/about" style={styles.link}>About</a></li>
              <li><a href="/projects" style={styles.link}>Projects</a></li>
              <li><a href="/service" style={styles.link}>Services</a></li>
              <li><a href="/contact" style={styles.link}>Contact</a></li>
              <li><a href="/industries" style={styles.link}>Industry</a></li>
              <li><a href="/blog" style={styles.link}>Blog</a></li>
            </ul>
          </div>

          {/* Column 3 - Contact */}
          <div style={styles.footerColumn}>
            <h2 style={styles.heading}>Contact Us</h2>
            <p style={styles.contactText}>
              E-mail: <a href="mailto:samson.sundaram@gmail.com" style={styles.link}><strong>samson.sundaram@gmail.com</strong></a>
            </p>
            <p style={styles.contactText}>
              Phone: <a href="tel:9443191026" style={styles.link}><strong>94431 91026</strong></a>
              <a href="tel:8870267057" style={styles.link}><strong> 8870267057</strong></a>
            </p>
            <p style={styles.contactText}>
              Landline: <a href="tel:+914344277711" style={styles.link}><strong>+91 4344 277711</strong></a>
            </p>
          </div>

      
          
{/* Column 4 - Address */}
<div style={styles.footerColumn}>
  <h2 style={styles.heading}>Address</h2>
  <a 
    href="https://www.google.co.in/maps/place/Samson+and+Associates(+Architects,civil+engineering)/@12.7437347,77.8090896,17z/data=!3m1!4b1!4m6!3m5!1s0x3bae71023673a587:0xbed17c79ab49505f!8m2!3d12.7437347!4d77.8116645!16s%2Fg%2F11j8vz8m0c?entry=ttu&g_ep=EgoyMDI1MDQwOS4wIKXMDSoASAFQAw%3D%3D" 
    target="_blank" 
    rel="noopener noreferrer"
    style={{ ...styles.contactText, textDecoration: "none", color: "inherit", cursor: "pointer" }}
  >
    A- 86, Sipcot Housing Colony,Dharga, Hosur-635 126.
  </a>
</div>


            {/* <h2 style={styles.heading}>Branch Address</h2>
            <p style={styles.contactText}>Plot No.5, 2nd Cross Street, Venkateswara Nagar, Pozhichalur,Chennai - 600074.</p> */}
        
            
          </div>
        </div>

      {/* Footer Banner Section */}
      <div style={styles.footerBanner}>
        <p>&copy; {new Date().getFullYear()} Samson and Associates. All Rights Reserved. Design and Developed by <span style={{fontWeight:"bold", textAlign:"right"}}>thequantumcraft</span></p>
        
      </div>
    </footer>
  );
};

export default Footer;
